import { API_URL } from './Constants';
import ApiService from './ApiService';

class BaiGIangPhoThongPageApi {
    static getChitietVideo = async (postId) => {
        try {
            let params = {};
            if (postId !== null) {
                params = { postId };
            }
            return await ApiService.getDataWithParams(API_URL + "/bai-giang-pho-thong/detail", params);
        } catch (error) {
        }
    };

    static getVideosMoiNhat = async (pageNumber) => {
        try {
            let params = {};
            if (pageNumber !== null) {
                params = { pageNumber };
            }
            return await ApiService.getDataWithParams(API_URL + "/bai-giang-pho-thong/new-bai-giang", params);
        } catch (error) {
        }
    };

    static getVideosXemNhieu = async (pageNumber) => {
        try {
            let params = {};
            if (pageNumber !== null) {
                params = { pageNumber };
            }
            return await ApiService.getDataWithParams(API_URL + "/bai-giang-pho-thong/top-view", params);
        } catch (error) {
        }
    };

    static getVideosTaiNhieu = async (pageNumber) => {
        try {
            let params = {};
            if (pageNumber !== null) {
                params = { pageNumber };
            }
            return await ApiService.getDataWithParams(API_URL + "/bai-giang-pho-thong/top-download", params);
        } catch (error) {
        }
    };
}
export default BaiGIangPhoThongPageApi;